export const REDEN_VAN_STATUS_IN_AANMAAK = "1";
export const REDEN_VAN_STATUS_INACTIEF = "2";
export const REDEN_VAN_STATUS_INGEDIEND = "121450000";
export const MAN = "121450000";

export const HAS_CONCURRENCY_EXCEPTION = "HAS_CONCURRENCY_EXCEPTION";
export const HAS_VALIDATION_ERRORS_SAVED = "HAS_VALIDATION_ERRORS_SAVED";
export const HAS_VALIDATION_ERRORS = "HAS_VALIDATION_ERRORS";
export const HAS_FILE_EXCEPTION = "HAS_FILE_EXCEPTION";
export const SUCCESS = "SUCCESS";
export const PDF_GENEREREN = "PDF_GENEREREN";
export const PDF_SIMULATIE_GENEREREN = "PDF_SIMULATIE_GENEREREN";

export const DomainScopes = {
    DEFAULT: "default"
};

export const KeyPressNumbers = {
    ENTER: 13
};

export const AccountTypes = {
    ORGANISATOR: "121450000",
    KOEPELORGANISATIE: "121450001",
    GEMEENTE: "121450002",
    FEDERATIE: "121450003",
};

export const RechtspersoonlijkheidTypes = {
    VZW: 121450000,
    FEITELIJKE_VERENIGING: 121450001,
    ANDERE: 121450002
};

export const Landen = {
    BELGIE: "0e5db0e6-e457-e611-80de-c4346bacceb8"
};

export const WedstrijdverbandTypes = {
    TOEGESTAAN: 100000000,
    VERBODEN: 100000001,
    VERBODEN_VOOR_MANNEN: 100000002,
    SPORTAFHANKELIJK: 100000003,
    AFHANKELIJK_VAN_CONCENTRATIE: 100000004,
    AFHANKELIJK_VAN_TOEDIENINGSWIJZE: 100000005,
    AFHANKELIJK_VAN_TOEDIENINGSWIJZE$CONCENTRATIE: 100000006
};

export const PortaalTeksten = {
    BEHEER_GENEESMIDDELEN_TITEL: "Beheer geneesmiddelen titel",
    BEHEER_GENEESMIDDELEN_SUBTITEL: "Beheer geneesmiddelen subtitel",
    DISCLAIMER_HTML: "Disclaimer HTML"
};